export default "__VITE_ASSET__D7eh30qI__"